import React from "react"
import { useTranslation } from "react-i18next"
import { OperationSaleListPage } from "./OperationSaleListPage"
import type { Sale } from "../../types"
import { formatDateToBR } from "../../utils/formatters"

export const OperationDeliveriesPage: React.FC = () => {
  const { t } = useTranslation()
  const extraColumns = (sale: Sale) => (
  <div className="text-xs text-muted-foreground space-y-0.5 mt-1">
  {sale.deliveryAt && (
  <p>
  {t("operation.delivery.scheduledAt")}: {formatDateToBR(sale.deliveryAt)}
  </p>
  )}
  {sale.deliveryResponsible?.name && (
  <p>
  {t("operation.delivery.responsible")}: {sale.deliveryResponsible.name}
  </p>
  )}
  </div>
  )
  return (
  <OperationSaleListPage
   statusFilter="delivered"
   titleKey="operation.deliveries.title"
   subtitleKey="operation.deliveries.subtitle"
   progressStageKey="delivery"
   extraColumns={extraColumns}
   getSaleDetailPath={(saleId) => `/operation/preparation/${saleId}`}
  />
  )
}
